module.exports = __webpack_public_path__ + "img/person.4e66fa2d.svg";